import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routes";

const queryClient = new QueryClient();

/**
 * App shell: providers + route outlet.
 *
 * Deliberately does NOT include a Router — the router is supplied by whichever
 * entry point renders this tree, so the same component works for both:
 *   - src/main.tsx      -> <BrowserRouter> (browser, hydration)
 *   - src/entry-server.tsx -> <StaticRouter> (Node, build-time prerender)
 *
 * Routes themselves live in src/routes.tsx — add new ones there, not here.
 */
const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Routes>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
